<ngx-spinner 
bdColor="rgba(255,255,255,0)"
size="medium"
color="#333333"
type="line-scale-party" 
>
    <h3>Loading...</h3>
</ngx-spinner>

<router-outlet></router-outlet>

